import {isEmpty} from '../lib/isEmpty';
import { isDTS } from '../../utility/platform';
import {
    getMinAge,
    ageFromDob,
    isExcludedState,
    EXCLUDED_JURISDICTION_MESSAGE,
} from '../../utility/complianceCopy';

var numbers = /^[0-9]+$/;


export const validateRegister = (value) => {
    let errors = {};
    let emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,6}))$/;
    let passwordRegex = /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*\W).{6,18}(?!\S)/;
    var letters = /^[A-Za-z\s]*$/;

    if (isEmpty(value.firstName)) {
        errors.firstName = "First Name field is required"
    } else if (!(letters.test(value.firstName))) {
        errors.firstName = "Invalid First Name"
    }

    if (isEmpty(value.lastName)) {
        errors.lastName = "Last Name field is required"
    } else if (!(letters.test(value.lastName))) {
        errors.lastName = "Invalid Last Name"
    }

    if (isEmpty(value.emailId)) {
        errors.emailId = "Email ID field is required"
    } else if (!(emailRegex.test(value.emailId))) {
        errors.emailId = "Invalid Email ID"
    }


    if (isEmpty(value.dateOfBirth)) {
        errors.dateOfBirth = "Date of birth field is required"
    }

    if (isEmpty(value.password)) {
        errors.password = "Password field is required"
    }else if ((value.password.length < 6) || (value.password.length > 18)) {
        errors.password = "Password must be between 6-18 characters"
    }else if (!(passwordRegex.test(value.password))) {
        errors.password = "Password should contain atleast one uppercase, one lowercase, one number, one special character"
    } 

    if (isEmpty(value.confirmPassword)) {
        errors.confirmPassword = "Confirm Password field is required"
    } else if (!(isEmpty(value.confirmPassword)) && value.password != value.confirmPassword) {
        errors.confirmPassword = "Password and confirm password should match"
    }

    // DTS sweepstakes compliance gating (does not run on PPH). This is a UX
    // convenience only — the authoritative check is server-side, see
    // backend/Helper/complianceValidation.js, because this can be bypassed
    // by calling the API directly.
    if (isDTS()) {
        // 21+ age check, derived from the provided date of birth.
        if (!isEmpty(value.dateOfBirth)) {
            const age = ageFromDob(value.dateOfBirth);
            if (age === null) {
                errors.dateOfBirth = "Please enter a valid date of birth";
            } else if (age < getMinAge()) {
                errors.dateOfBirth = `You must be at least ${getMinAge()} years old to register`;
            }
        }

        // State of residence required, and excluded jurisdictions blocked.
        if (isEmpty(value.state)) {
            errors.state = "State of residence is required";
        } else if (isExcludedState(value.state)) {
            errors.state = EXCLUDED_JURISDICTION_MESSAGE;
        }

        // Must affirm 21+ and agree to the rules.
        if (!value.agreeAge) {
            errors.agreeAge = `You must confirm you are ${getMinAge()}+ and agree to the Official Rules`;
        }

        // CAPTCHA must be solved (UX convenience only — the server verifies the
        // token independently in backend/Helper/captchaVerification.js).
        if (isEmpty(value.captchaToken)) {
            errors.captchaToken = "Please complete the CAPTCHA challenge";
        }
    }

    return errors;
}